import { render, staticRenderFns } from "./TagListAddNew.vue?vue&type=template&id=354b8aec&"
import script from "./TagListAddNew.vue?vue&type=script&lang=js&"
export * from "./TagListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TagListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports